import { atom } from 'recoil'
import { Cart } from 'src/types/cart'
import { CurrencyCode } from 'types/storefront.types'

const defaultCart: Cart = {
  id: '',
  updatedAt: null,
  checkoutUrl: '',
  discountAllocations: [],
  discountCodes: [],
  lines: {
    edges: []
  },
  cost: {
    subtotalAmount: {
      amount: '0',
      currencyCode: CurrencyCode.Usd
    },
    totalAmount: {
      amount: '0',
      currencyCode: CurrencyCode.Usd
    },
    totalTaxAmount: {
      amount: '0',
      currencyCode: CurrencyCode.Usd
    },
    totalDutyAmount: {
      amount: '0',
      currencyCode: CurrencyCode.Usd
    }
  }
}

export type CartState = {
  fetching: boolean
  updating: boolean
  cart: Cart
}

export const shopifyCartState = atom<CartState>({
  key: 'shopifyCart',
  default: {
    fetching: true,
    updating: false,
    cart: defaultCart
  }
})
